<template>
  <TextareaOptionalValidation
    v-model="OptionalValidationModel"
    v-validate="config.validate || ''"
    v-bind="config"
    :cols="cols"
    :onlyBreakAtNewlines="onlyBreakAtNewlines"
    :resizeable="resizeable"
    :rows="rows"
    :smallInput="smallInput"
    :tooltip="tooltip"
    @blur="handleBlur"
    @enter="handleEnter"
    @input="handleInput"
  />
</template>

<script>
import TextareaOptionalValidation from 'client/components/FormValidation/Textarea.vue';
import TooltipPropMixin from 'components/FormValidation/mixins/TooltipPropMixin';
import ValidatorMixin from 'client/components/FormValidation/mixins/ValidatorMixin';

export default {
  name: 'TextareaValidator',

  components: { TextareaOptionalValidation },

  mixins: [
    ValidatorMixin,
    TooltipPropMixin,
  ],

  props: {
    cols: {
      type: Number,
      default: null,
    },
    onlyBreakAtNewlines: {
      default: false,
      type: Boolean,
    },
    resizeable: {
      default: false,
      type: Boolean,
    },
    rows: {
      type: Number,
      default: null,
    },
    smallInput: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
